/**
 * Created by Jerker Nord on 2019-11-25.
 */

import {TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class BonusBunniesSpineSymbol extends PIXI.spine.Spine {

    private _originalSymPosition:PIXI.Point;
    private _currentSymPosition:PIXI.Point;
    private _symbolState:string;
    private _stateTL:TimelineLite;

    constructor(spineData:PIXI.spine.core.SkeletonData) {
        super(spineData);
        this._originalSymPosition = new PIXI.Point();
        this._currentSymPosition = new PIXI.Point();
    }

    public setSymbolState(newState:string, loopValue:number = -1) {
        this._symbolState = newState;
        if(this._stateTL && this._stateTL.isActive()) {
            this._stateTL.pause();
            this._stateTL.kill();
        }
        this._stateTL = new TimelineLite();
        if(newState == "jump_V") {
            this.state.timeScale = 3.1;
        } else {
            this.state.timeScale = 1;
        }

        this._stateTL.add(new SpineTween(this, 0, newState, loopValue));
    }

    public killStateTL():void {
        if(this._stateTL && this._stateTL.isActive()) {
            this._stateTL.pause();
            this._stateTL.kill();
        }
    }

    public setStartPosition(reel:number, row:number):void {
        this._originalSymPosition.x = reel;
        this._originalSymPosition.y = row;
        this._currentSymPosition.x = reel;
        this._currentSymPosition.y = row;
        const symbolPosition:[number, number] = Helper.getSymbolPositions(reel, row);
        this.position.x = symbolPosition[0];
        this.position.y = symbolPosition[1];
    }

    set originalSymPosition(value:PIXI.Point) {
        this._originalSymPosition = value;
    }

    get originalSymPosition():PIXI.Point {
        return this._originalSymPosition;
    }

    get symbolState():string {
        return this._symbolState;
    }

    get currentSymPosition():PIXI.Point {
        return this._currentSymPosition;
    }

    set currentSymPosition(value:PIXI.Point) {
        this._currentSymPosition = value;
    }
}